import React from 'react';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import List from '@mui/material/List';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import SubuserDeviceItemComponent from './Subuser-device-item.component';
import RemoveDeviceContainer from '../Remove-device/Remove-device.container';
import EditSubuserRightsContainer from '../Edit-subuser-rights/Edit-subuser-rights.container';
import AlertComponent from '@ui/components/Alert/Alert.component';
import useDictionary from '@ui/hooks/useDictionary';
import { IProps } from './IProps';

const Component: React.FC<IProps> = ({
    lang,
    selectedSubuser,
    subusersDevices,
    devices,
    serverError,
    deviceBtnHover,
    deleteDeviceVisible,
    editSubuserRightsVisible,
    onDeviceBtnHoverStart,
    onDeviceBtnHoverStop,
    onDeleteDeviceOpen,
    onDeleteDeviceClose,
    onEditSubuserRightsOpen,
    onEditSubuserRightsClose,
    onClose,
}: IProps) => {
    const getWord = useDictionary();

    const [subuserItem] = subusersDevices.filter(
        ({ subuser }) => subuser === selectedSubuser,
    );
    let deviceList: string[] = [];
    if (subuserItem && subuserItem.devices) deviceList = subuserItem.devices;
    const getListElement = () => {
        if (deviceList.length !== 0) {
            const list = deviceList.map((imei) => {
                const [device] = devices.filter(
                    (device) => device.imei === imei,
                );
                const name = device ? device.name : '';
                return (
                    <SubuserDeviceItemComponent
                        name={name}
                        imei={imei}
                        key={imei}
                        deviceBtnHover={deviceBtnHover}
                        onDeviceBtnHoverStart={onDeviceBtnHoverStart}
                        onDeviceBtnHoverStop={onDeviceBtnHoverStop}
                        onDeleteDeviceOpen={onDeleteDeviceOpen}
                        onEditSubuserRightsOpen={onEditSubuserRightsOpen}
                    />
                );
            });
            return <List className="subuser-devices__list">{list}</List>;
        } else
            return (
                <Typography
                    className="subuser-devices__overlay"
                    variant="body1"
                >
                    {getWord('noDevices')}
                </Typography>
            );
    };
    const list = getListElement();

    return (
        <>
            <Box className="subuser-devices">
                <IconButton className="close-btn" onClick={onClose}>
                    <CloseIcon className="close-btn__ico" />
                </IconButton>
                <Typography className="subuser-devices__title" variant="h6">
                    {getWord('subuserDevicesTitle')}
                </Typography>
                <AlertComponent
                    variant="modal"
                    severity="error"
                    message="serverError"
                    display={serverError}
                    lang={lang}
                />
                {list}
                <Box className="subuser-devices__btn-bar">
                    <Button
                        className="subuser-devices__btn"
                        variant="contained"
                        color="error"
                        onClick={onClose}
                    >
                        {getWord('close')}
                    </Button>
                </Box>
            </Box>
            <Modal open={deleteDeviceVisible} onClose={onDeleteDeviceClose}>
                <RemoveDeviceContainer onClose={onDeleteDeviceClose} />
            </Modal>
            <Modal
                open={editSubuserRightsVisible}
                onClose={onEditSubuserRightsClose}
            >
                <EditSubuserRightsContainer
                    onClose={onEditSubuserRightsClose}
                />
            </Modal>
        </>
    );
};

const SubuserDevicesComponent = React.memo(Component);

export default SubuserDevicesComponent;
